import { Box, Skeleton, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material'
import { updateFieldValue } from '../../../../../../../store/actions/analytics.actions'
import React, { useState } from 'react'
import useAnalyticsCurriculum from '../../../../../../../hooks/analytics/useAnalyticsCurriculum'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import FormatDate from '../../../../../../date/FormatDate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import IconTooltipButton from '../../../../../../button/IconTooltipButton'
import DialogConfirmCancel from '../../../../../../dialog/DialogConfirm'

const List = () => {
  const dispatch = useDispatch()
  const { getHistory, deleteHistory } = useAnalyticsCurriculum()
  const historyList = useSelector((state) => state?.analytics?.analyticsCurriculum?.historyList || [])
  const historyLoading = useSelector(
    (state) => state?.analytics?.analyticsCurriculum?.historyLoading || false
  )
  const state = useSelector((state) => state?.filter?.analyticsCurriculumHistory || {})
  const [modalOpen, setModalOpen] = useState(false)

  const history = useSelector((state) => state?.analytics?.analyticsCurriculum?.history || null)
  useEffect(() => {
    getHistory(state?.filter)
  }, [state?.filter])

  const onClickHistory = (history) => {
    dispatch(updateFieldValue('analyticsCurriculum', 'history', history))
  }

  return (
    <Table>
      <TableBody>
        {historyLoading &&
          Array.from({ length: 10 }).map((_, index) => (
            <TableRow key={index}>
              <TableCell key={index}>
                <Box className='px-2 py-2 flex flex-col gap-1'>
                  <Typography variant='h6' color='textSecondary'>
                    <Skeleton variant='text' width={100} height={20} />
                  </Typography>
                  <Typography variant='h6' color='textSecondary'>
                    <Skeleton variant='text' width={150} height={10} />
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        {!historyLoading && historyList.length === 0 && (
          <TableRow>
            <TableCell>
              <Typography v color='textSecondary' className='text-center py-4'>
                {"You don't have any history yet"}
              </Typography>
            </TableCell>
          </TableRow>
        )}
        {!historyLoading &&
          historyList.map((h) => (
            <TableRow
              key={h._id}
              className={h.progress?.status === 'completed' ? 'cursor-pointer bg-clickeabled2' : ''}
              onClick={() => (h.progress?.status === 'completed' ? onClickHistory(h) : null)}
            >
              <TableCell className='py-0 flex justify-between items-center pr-2 pl-0'>
                <Box
                  className={
                    h._id === history?._id
                      ? 'text-primary border-l border-2 border-primary px-2 py-2'
                      : 'text-muted-foreground py-2 px-2 '
                  }
                >
                  <Typography className='text-lg font-bold'>{h.description}</Typography>
                  <Typography variant='caption'>
                    Generated at: <FormatDate date={h.createdAt} pattern='dd/MMM/yyyy HH:mm a' />
                  </Typography>
                </Box>
                {h.progress?.status !== 'completed' && (
                  <Tooltip
                    title={`${h.progress?.status} (${parseInt(h.progress?.value || 0)}%)`}
                    placement='top'
                  >
                    <span>
                      <FontAwesomeIcon icon='circle-notch' size='lg' spin />
                    </span>
                  </Tooltip>
                )}
                {h.progress?.status === 'completed' && (
                  <IconTooltipButton
                    icon='trash'
                    onClick={(e) => {
                      e.stopPropagation()
                      setModalOpen(h._id)
                    }}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
      {modalOpen && (
        <DialogConfirmCancel
          open={!!modalOpen}
          onClose={() => setModalOpen(null)}
          onConfirm={() => {
            deleteHistory(modalOpen)
            setModalOpen(null)
          }}
          title='Delete history'
          maxWidth='xs'
        >
          <Typography>Are you sure you want to delete this history? This action cannot be undone.</Typography>
        </DialogConfirmCancel>
      )}
    </Table>
  )
}

export default List
